import { Box, Breadcrumbs, Link, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { Outlet, useNavigate } from 'react-router-dom';

import { getAnnotationToolSupervisorProjectPath } from '@verantos-dev/core-annotation-tool';
import { ProjectStats } from '@verantos-dev/feature-annotation-project-admin';

import { SupervisorProjectOverview } from './components/SupervisorProjectOverview/SupervisorProjectOverview';
import { SUPERVISOR_PROJECT_TABS } from './constants';
import { useSupervisorProjectDetails } from './useSupervisorProjectDetails';

export const SupervisorProjectDetails = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const {
    projectName,
    createdOn,
    startedOn,
    completedOn,
    isProjectDetailsLoading,
    showMetricsTab,
    isMetricsAccessLoading,
    selectedTab,
    handleTabChange,
  } = useSupervisorProjectDetails();

  const navigate = useNavigate();
  const handleBackToProjects = () => {
    navigate(getAnnotationToolSupervisorProjectPath());
  };

  return (
    <Box
      sx={{
        px: theme.spacing(6),
        py: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Box>
        <Breadcrumbs sx={{ fontSize: '16px' }} separator="/">
          <Link
            color="inherit"
            underline="hover"
            onClick={handleBackToProjects}
            sx={{ cursor: 'pointer' }}
          >
            {formatMessage({
              id: 'supervisorProjects.projectDetails.breadcrumb.supervisorProjects',
            })}
          </Link>
          <Link color="inherit" underline="none" sx={{ fontWeight: '500' }}>
            {projectName}
          </Link>
        </Breadcrumbs>
      </Box>
      <Box>
        <Typography variant="h4">{projectName}</Typography>
      </Box>
      <Box>
        <ProjectStats
          createdOn={createdOn}
          startedOn={startedOn}
          completedOn={completedOn}
          isLoading={isProjectDetailsLoading}
        />
      </Box>
      {showMetricsTab && (
        <Box>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            sx={{ mb: theme.spacing(5), borderBottom: `1px solid ${theme.palette.divider}` }}
          >
            <Tab
              label={formatMessage({ id: 'supervisorProjects.projectDetails.tab.overview' })}
              value={SUPERVISOR_PROJECT_TABS.OVERVIEW}
              sx={{ textTransform: 'none', fontSize: '14px', fontWeight: '500' }}
            />
            <Tab
              label={formatMessage({ id: 'supervisorProjects.projectDetails.tab.metrics' })}
              value={SUPERVISOR_PROJECT_TABS.METRICS}
              sx={{ textTransform: 'none', fontSize: '14px', fontWeight: '500' }}
            />
          </Tabs>
        </Box>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {isMetricsAccessLoading ? null : showMetricsTab ? (
          <Outlet />
        ) : (
          <SupervisorProjectOverview />
        )}
      </Box>
    </Box>
  );
};
